export var BogEntryTypeEnum;
(function (BogEntryTypeEnum) {
    // სალარო ოპერაცია
    BogEntryTypeEnum["PMC"] = "PMC";
    // საბარათე ოპერაცია merchant doesnt use it
    BogEntryTypeEnum["PLC"] = "PLC";
    // ანაბრის ოპერაცია
    BogEntryTypeEnum["CDS"] = "CDS";
    // სესხის ოპერაცია
    BogEntryTypeEnum["LND"] = "LND";
    // ფეიბოქსის ოპერაცია
    BogEntryTypeEnum["PBS"] = "PBS";
    // ინკასო
    BogEntryTypeEnum["INC"] = "INC";
    // ეროვნული ვალუტის გადარიცხვა
    BogEntryTypeEnum["PMD"] = "PMD";
    // უცხოური ვალუტის გადარიცხვა
    BogEntryTypeEnum["PMI"] = "PMI";
    // საკომისიო
    BogEntryTypeEnum["COM"] = "COM";
    // merchant card transactions (both deposit and withdraw)
    BogEntryTypeEnum["TRN"] = "TRN";
    // exchange (GEL->USD, USD->GEL, ...)
    BogEntryTypeEnum["CCO"] = "CCO";
    // overdraft transaction
    BogEntryTypeEnum["OVD"] = "OVD";
    // ცნობის ფი
    BogEntryTypeEnum["FEE"] = "FEE";
})(BogEntryTypeEnum || (BogEntryTypeEnum = {}));
//# sourceMappingURL=bog-entry-type.enum.js.map